import React from 'react';
import TierGrid from '../TierGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import LoadingIndicator from '../../../LoadingIndicator';
import { useTiers } from '../../_hocs/withTiers';
import { MeasuredCookieType } from '../../../Measured';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardSemiDumb';
const TierSelector = ()=>{
    const { tiers, isTierStreamInitialized, isFetchingTiers } = useTiers();
    const renderTier = ({ index, width })=>{
        const tier = tiers[index];
        return /*#__PURE__*/ React.createElement(SelectableDeviationWrapper, {
            key: getDeviationEntityId(tier),
            deviation: tier
        }, /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, {
            width: width,
            deviation: tier,
            ctaButton: "view-subscribe"
        }));
    };
    const renderContent = ()=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isTierStreamInitialized && /*#__PURE__*/ React.createElement(TierGrid, {
            cookieType: MeasuredCookieType.GALLECTION_EXPLORER,
            tiers: tiers,
            tierRenderer: renderTier,
            isTierPromotion: true
        }), isFetchingTiers && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !tiers.length
        }));
    };
    return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
        scrollableContent: renderContent()
    });
};
TierSelector.displayName = 'TierSelector';
export default TierSelector;
